const getters = {
	navOptions: state => state.dict.navOptions,
}
export default getters
